import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import WebrtcProvider from "./modules/Webrtc";

import { ThemeProvider } from "@mui/material/styles";
import theme from "./assets/themes";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <WebrtcProvider>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </WebrtcProvider>
  </React.StrictMode>
);

console.error = () => {};
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
